<mat-progress-bar
  *ngIf="!articles"
  class="example-margin"
  [color]="'primary'"
  [mode]="'query'">
</mat-progress-bar>

<section class="container" *ngIf="articles">
  <span class="container__info">
    <mat-icon>info</mat-icon>A weekly updated list of the most requested articles from Article Galaxy customers. It represents a unique cross-publisher and multi-industry snapshot of relevant COVID-19 studies.
  </span>
  <mat-card *ngFor="let item of articles; index as i">
      <mat-card-header>
            <span class="container__index">{{i + 1}}</span>
            <section class="container__all">
              <mat-card-title>{{item.title}}</mat-card-title>
               <mat-card-subtitle>
              <div class="container__content">
                <div class="container__content__info">
                  <strong>Publications: </strong> {{item.publication}}
                </div>
                <div class="container__content__info">
                  <strong>Author(s):</strong>
                  <span *ngFor="let author of item.authors; last as isLast">
                  {{author}}{{isLast ? '.' : ','}}
                  </span>
                </div>
                <div class="container__content__info">
                  <span><strong>Year:</strong> {{item.year}} </span>
                  <span><strong>| DOI:</strong> {{item.doi}} </span>
                  <span><strong>| PMID:</strong> {{item.pmid}} </span>
                  <span><strong>| ISSN:</strong> {{item.issn}} </span>
                </div>
              </div>
              <div>
                <div class="altmetric-embed
                  altmetric-doi-{{item.doi}}"
                  data-badge-popover="left"
                  data-badge-type="donut"
                  data-hide-no-mentions="true"
                  rel="noreferrer"
                  data-template="reprintsdesk"
                  data-link-target="_blank">
                </div>
              </div>
            </mat-card-subtitle>
            </section>
      </mat-card-header>
      <mat-card-content>
        <section class="container__content__abstract">
          <a *ngIf="item.abstract && item.abstract.length > 350"
            mat-button
            (click)="item.show = !item.show">
            {{ item.show ? 'Hide Full Abstract' : 'Read Full Abstract'}}
              <mat-icon
                *ngIf="item.show"
                aria-hidden="false"
                aria-label="Show abstract">
                keyboard_arrow_up
              </mat-icon>
              <mat-icon
                *ngIf="!item.show"
                aria-hidden="false"
                aria-label="Hide abstract">
                keyboard_arrow_down
              </mat-icon>
          </a>
          <a class="" *ngIf="item.abstract && item.abstract.length < 350">Abstract</a>
        </section>
        <section class="container__content__abstract__text">
          <p *ngIf="item.show">{{item.abstract}}</p>
          <p *ngIf="item.abstract && !item.show">{{item.liteAbstract}}</p>
        </section>

      </mat-card-content>
      <mat-card-actions class="container__content__abstract__action" >
          <a mat-stroked-button rel="noreferrer" href="https://doi.org/{{item.doi}}" target="_blank">
            Read Full-Text
            <mat-icon aria-hidden="false" aria-label="Read Full-Text">open_in_new</mat-icon>
          </a>
      </mat-card-actions>
  </mat-card>
</section>
